import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    roleData: {},
    roleList: [],
    permissionsList: [],

    loading: false,
    loadingGetRequest: false,
    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    roleWasCreated: false,
    roleWasEdited: false,
    roleWasDeleted: false,

    error: undefined
};

const rolesReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.GET_ROLE_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: undefined
            };
        case actionTypes.GET_ROLE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                roleList: payload,
                error: undefined
            };
        case actionTypes.GET_ROLE_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case actionTypes.ROLE_SEARCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: undefined
            };
        case actionTypes.ROLE_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                error: undefined,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_ROLE_REQUEST:
            return {
                ...state,
                loadingGetRequest: true,
                error: undefined
            };
        case actionTypes.GET_ROLE_SUCCESS:
            return {
                ...state,
                loadingGetRequest: false,
                error: undefined,
                roleData: payload,
                permissionsList: payload.permissionsList
            };
        case actionTypes.GET_ROLE_FAILED:
            return {
                ...state,
                loadingGetRequest: false,
                error: payload
            };
        case actionTypes.GET_PERMISSION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: undefined
            };
        case actionTypes.GET_PERMISSION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                error: undefined,
                permissionsList: payload
            };
        case actionTypes.GET_PERMISSION_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case actionTypes.DELETE_ROLE_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true,
                error: undefined
            };
        case actionTypes.DELETE_ROLE_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                error: undefined,
                roleWasDeleted: true
            };
        case actionTypes.DELETE_ROLE_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                roleWasDeleted: false,
                error: payload
            };
        case actionTypes.EDIT_ROLE_REQUEST:
            return {
                ...state,
                loadingEditRequest: true,
                error: undefined
            };
        case actionTypes.EDIT_ROLE_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                error: undefined,
                roleWasEdited: true
            };
        case actionTypes.EDIT_ROLE_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                roleWasEdited: false,
                error: payload
            };
        case actionTypes.CREATE_ROLE_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true,
                error: undefined
            };
        case actionTypes.CREATE_ROLE_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                roleWasCreated: true,
                error: undefined
            };
        case actionTypes.CREATE_ROLE_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                roleWasCreated: false,
                error: payload
            };
        case actionTypes.RESET_ROLE_FORM:
            return {
                ...state,
                roleData: {},
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                roleWasCreated: false,
                roleWasEdited: false,
                roleWasDeleted: false,
                error: undefined
            };
        default:
            return state;
    }
};

export default rolesReducer;